import { Label } from "@/components/base/input/label";
import { FilterPanelContainer, FilterPanelHeader } from "@/components/filters/shared";
import { Form, FormField } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFilters } from "@/providers/filter-provider";

type SequenceOption = { id: string; name: string };

interface SequenceRunFilterPanelProps {
  open: boolean;
  close: () => void;
  sequences: SequenceOption[];
}

export const SequenceRunFilterPanel = ({ open, close, sequences }: SequenceRunFilterPanelProps) => {
  const { form, reset } = useFilters();

  return (
    <FilterPanelContainer open={open}>
      <FilterPanelHeader onClear={reset} onClose={close} />
      <div className="flex-1 overflow-y-auto px-6 pb-6">
        <Form {...form}>
          <div className="flex flex-col gap-4">
            <FormField
              control={form.control}
              name="sequenceRunSequence"
              render={({ field }) => (
                <div className="flex flex-col gap-2">
                  <Label className="text-sm text-tertiary">Sequence</Label>
                  <Select
                    value={field.value?.id ?? "all"}
                    onValueChange={(value) => {
                      if (value === "all") {
                        field.onChange(undefined);
                      } else {
                        const seq = sequences.find((s) => s.id === value);
                        if (seq) field.onChange({ id: seq.id, label: seq.name });
                      }
                    }}
                  >
                    <SelectTrigger className="w-full h-9 text-sm">
                      <SelectValue placeholder="All Sequences" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">All Sequences</SelectItem>
                      {sequences.map((s) => (
                        <SelectItem key={s.id} value={s.id}>
                          {s.name}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}
            />

            <FormField
              control={form.control}
              name="sequenceRunStatus"
              render={({ field }) => (
                <div className="flex flex-col gap-2">
                  <Label className="text-sm text-tertiary">Status</Label>
                  <Select
                    value={field.value ?? "all"}
                    onValueChange={(value) => {
                      field.onChange(value === "all" ? undefined : value);
                    }}
                  >
                    <SelectTrigger className="w-full h-9 text-sm">
                      <SelectValue placeholder="All Statuses" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">All Statuses</SelectItem>
                      <SelectItem value="active">Active</SelectItem>
                      <SelectItem value="completed">Completed</SelectItem>
                      <SelectItem value="cancelled">Cancelled</SelectItem>
                      <SelectItem value="failed">Failed</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              )}
            />
          </div>
        </Form>
      </div>
    </FilterPanelContainer>
  );
};
